<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" id="about-main">
      <div>
        <h1>Estornar Crédito Escola</h1>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "blank",
  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },
  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
  }
}
</script>